import { NonCredlyCert } from "./nonCredlyCerts";

/** Years present in the given set, most recent first. */
export const getYears = (certs: NonCredlyCert[]): number[] =>
	Array.from(new Set(certs.map((c: NonCredlyCert) => c.year))).sort((a, b) => b - a);

/**
 * Credentials awarded in a given year. Grouping is by credential, not by
 * certificate file — a credential with two scanned files (e.g. Green Belt and
 * Black Belt) is one card carrying both, not two indistinguishable cards.
 */
export const groupByYear = (certs: NonCredlyCert[], year: number): NonCredlyCert[] =>
	certs.filter((c: NonCredlyCert) => c.year === year);
